/**
 * Each uploaded image lives twice in the wizard state: `mediaPreviews` holds the
 * local blob URL and `generatedImages` holds the uploaded copy (CreativeStep
 * writes both). Uploaded images are what actually launches, and their URL stays
 * valid across step changes and page reloads — where the local blob does not —
 * so prefer them and fall back to local previews only for files whose upload
 * hasn't landed yet.
 */
export function resolveSlotImageUrls(
  generated: { imageUrl: string }[] | undefined,
  previews: string[] | undefined,
): string[] {
  return generated?.length ? generated.map((image) => image.imageUrl) : (previews ?? []);
}
